<template>
  <el-container id="app">
    <el-header>
      <el-menu
        :default-active="$route.path"
        router
        mode="horizontal"
        text-color="#AAAAAA"
        active-text-color="#409EFF"
      >
        <el-menu-item v-for="(item,i) in navList" :key="i" :index="item.name">{{item.navItem}}</el-menu-item>
        <li class="signinup" index="2">
          <el-button class="adusername" type="text" v-show="!authed">{{username}}</el-button>
          <el-dropdown trigger="click" v-show="authed" @command="handleCommand">
            <span class="el-dropdown-link sign">
              {{username}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑资料</el-dropdown-item>
              <el-dropdown-item command="reset">重置密码</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button class="sign" type="text" @click="Login" v-show="!authed">登录/注册</el-button>
          <el-button class="sign" type="text" @click="Logout" v-show="authed">注销</el-button>
        </li>
      </el-menu>
    </el-header>
    <router-view transition="fade" transition-mode="out-in"/>
    <el-footer height="100px">
      <div class="footcontent">
        <div>
          <small>©2019 Rerepeater</small>
        </div>
        <div>
          <small>Empower researchers to achieve more</small>
        </div>
        <div>
          <small>Powered By .Net Core on Microsoft Azure</small>
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import * as Msal from "../node_modules/msal";

var applicationConfig = {
  clientID: "d327cb85-7aa0-4cd6-8015-16c89af9078e",
  authority:
    "https://repeater.b2clogin.com/tfp/repeater.onmicrosoft.com/B2C_1_SiUpIn",
  b2cScopes: ["https://repeater.onmicrosoft.com/repeater/user_impersonation"]
};
var clientApplication = new Msal.UserAgentApplication(
  applicationConfig.clientID,
  applicationConfig.authority,
  function(errorDesc, token, error, tokenType) {
    // Called after loginRedirect or acquireTokenPopup
  },
  {
    storeAuthStateInCookie: true,
    validateAuthority: false
  }
);
var clientApplication_pro = new Msal.UserAgentApplication(
  applicationConfig.clientID,
  "https://repeater.b2clogin.com/tfp/repeater.onmicrosoft.com/B2C_1_SiPe",
  function(errorDesc, token, error, tokenType) {
    // Called after loginRedirect or acquireTokenPopup
  },
  {
    storeAuthStateInCookie: true,
    validateAuthority: false
  }
);
var clientApplication_pwd = new Msal.UserAgentApplication(
  applicationConfig.clientID,
  "https://repeater.b2clogin.com/tfp/repeater.onmicrosoft.com/B2C_1_SSPR",
  function(errorDesc, token, error, tokenType) {
    // Called after loginRedirect or acquireTokenPopup
  },
  {
    storeAuthStateInCookie: true,
    validateAuthority: false
  }
);
export default {
  name: "App",
  data() {
    return {
      navList: [
        { name: "/", navItem: "主页" },
        { name: "/favorites", navItem: "收藏" },
        { name: "/about", navItem: "关于" }
      ],
      username: "你好",
      authed: false
    };
  },
  mounted() {
    console.log("try read user info");
    this.updateUI();
  },
  methods: {
    Login: async function() {
      try {
        var idtoken = await clientApplication.loginPopup(
          applicationConfig.b2cScopes
        );
        this.Loging();
        try {
          var accesstoken = await clientApplication.acquireTokenSilent(
            applicationConfig.b2cScopes,
            applicationConfig.authority
          );
          this.updateUI();
          this.$globalevent.$emit("login");
        } catch (error) {
          try {
            var accesstoken = await clientApplication.acquireTokenPopup(
              applicationConfig.b2cScopes
            );
            this.updateUI();
          } catch (error) {
            this.Loginfail();
            console.log(error);
          }
        }
      } catch (error) {
        this.Loginfail();
        console.log(error);
      }
    },
    Logout: function() {
      // Removes all sessions, need to call AAD endpoint to do full logout
      clientApplication.logout();
      this.authed = false;
      this.username = "你好";
    },
    updateUI: function() {
      if (clientApplication.getUser() != null) {
        var userName = clientApplication.getUser().name;
        this.username = userName;
        this.authed = true;
        console.log(userName);
      }
    },
    Loging() {
      this.$notify.info({
        title: "消息",
        message: "登录中...",
        duration: 2333
      });
    },
    Loginfail() {
      this.$notify.error({
        title: "错误",
        message: "登录失败！",
        duration: 2333
      });
    },
    EditProfile() {
      clientApplication_pro.loginRedirect(applicationConfig.b2cScopes);
    },
    ResetPwd() {
      clientApplication_pwd.loginRedirect(applicationConfig.b2cScopes);
    },
    handleCommand(command) {
      if (command == "edit") {
        this.EditProfile();
      } else {
        this.ResetPwd();
      }
    }
  }
};
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
html {
  background: rgb(240, 240, 240);
}
body {
  display: flex;
  flex-flow: column;
  min-height: 100vh;
}
.el-footer {
  display: flex;
  background-color: #f6f6f6;
  align-items: center;
  justify-content: center;
}
.footcontent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: #616161;
  line-height: 24px;
}
.signinup {
  float: right !important;
  padding: 1px 20px 0 0;
}
.adusername,
.sign {
  color: rgb(170, 170, 170) !important;
  height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue